import { CreditCardBlockedIcon } from "@jti/brand-icons/credit-card-blocked";
import { useTranslations } from "@jti/ui";

import styles from "./PaymentSecure.module.scss";

export const PaymentSecure = () => {
  const { __ } = useTranslations();
  return (
    <div data-testid="secureBlock" className={styles.secureBlock}>
      <div className={styles.secureTitle}>
        <CreditCardBlockedIcon className={styles.secureIcon} />
        <span data-testid="payment-secure-title">{__("cart.checkout.payment.secure_payment.title")}</span>
      </div>
      <div data-testid="payment-secure-text" className={styles.secureTxt}>
        {__("cart.checkout.payment.secure_payment.text")}
      </div>
    </div>
  );
};
